export default __webpack_public_path__ + "static/media/3.4774bfb3.png";